"use client";
import { SCALE } from "@/components/tables/constants";
import cross from "../../assets/icons/close-square.svg";
import Image from "next/image";
import { useEffect } from "react";
import ScaleTable from "../tables/ScaleTable";

interface ScalePopupProps {
  category: string;
  close?: () => void;
}

export default function ScalePopup({ category, close }: ScalePopupProps) {
  // Lock body scroll when the popup is mounted
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  const scaleData = category == "aq" ? SCALE[0] : SCALE[1];

  return (
    <div className="fixed inset-0 top-5 lg:top-0 z-50 flex items-center justify-center modalbackground w-full h-full">
      <div className="z-50 flex flex-col text-white bg-neutral-dark-50 p-8  w-full lg:w-[60%] h-fit shadow-lg rounded-lg">
        <div className="flex-1 overflow-y-auto scrollbar-hidden">
          {scaleData?.content.map((content, index) => (
            <div key={index} className="space-y-4">
              {/* Title and close button for the first content block */}
              {content.title && (
                <div className="flex justify-between">
                  <h3 className="font-poppinsRegular font-semibold tracking-wide text-neutral-light-200 pt-6">
                    {content.title}
                  </h3>
                  {index === 0 && (
                    <Image
                      src={cross}
                      alt="Close Button"
                      width={31}
                      height={35}
                      className="cursor-pointer -mb-6 lg:mb-0"
                      onClick={close}
                    />
                  )}
                </div>
              )}

              {/* Paragraph content */}
              {content.para?.map((item: string, idx: number) => (
                <p
                  key={idx}
                  className="font-inter font-normal text-neutral-light-600 text-sm lg:text-base"
                >
                  {item}
                </p>
              ))}
              <div className="space-y-8">
                <ScaleTable category={category} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
